import {useInjex} from '@injex/react-plugin';
import ReportingParamsManager from '../../managers/reportingParamsManager.mdl';

export default function useReportingParamsManager(): ReportingParamsManager {
    const [inject] = useInjex();
    return inject<ReportingParamsManager>('reportingParamsManager');
}
